var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 20.75C14.0503 20.75 16.1964 19.8611 17.7787 18.2787C19.361 16.6964 20.25 14.5503 20.25 12.3125C20.25 10.0747 19.361 7.92862 17.7787 6.34629C16.1964 4.76395 14.0503 3.875 11.8125 3.875C9.57473 3.875 7.42862 4.76395 5.84628 6.34629C4.26394 7.92862 3.37499 10.0747 3.37499 12.3125C3.37499 14.5503 4.26394 16.6964 5.84628 18.2787C7.42862 19.8611 9.57473 20.75 11.8125 20.75ZM19.6526 18.7199L25.3108 24.3781L23.8781 25.8108L18.2199 20.1526C16.2087 21.7964 13.6426 22.6042 11.0524 22.4092C8.46221 22.2141 6.04607 21.031 4.30366 19.1046C2.56124 17.1782 1.62585 14.6558 1.69093 12.0591C1.756 9.46239 2.81657 6.99002 4.65329 5.1533C6.49001 3.31657 8.96238 2.25601 11.5591 2.19093C14.1558 2.12585 16.6782 3.06125 18.6046 4.80366C20.531 6.54607 21.7141 8.96222 21.9092 11.5524C22.1042 14.1426 21.2963 16.7087 19.6526 18.7199Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBtn);
export default __webpack_public_path__ + "static/media/searchBtn.8f68db98efea36b53e2c2b7d342fb776.svg";
export { ForwardRef as ReactComponent };